import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { get } from '@src/api/sharing';
import { getAppViewerModuleTempDashboardUrl } from '@src/components/common/Dashboard/utils/getTempDashboardUrl';
import { createTempDashboard } from '@src/store/tempDashboard/actions';
import { DASHBOARD_TYPE } from '@src/utils/constants';
import { Retry } from '@src/components/common';
import { EQueryIdType } from './types';

const AppTimelineSharePage = () => {
  const { id } = useParams();

  const [error, setError] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // from share
  useEffect(() => {
    setError(false);
    const fetchData = async () => {
      try {
        const res = await get(id);
        const state = JSON.parse(res.data.state);
        const sIdType = state.idType;
        const sFlowId = state.flowId;
        const sClientId = state.clientId;
        const sViewerId = state.viewerId;
        const sInterval = state.interval;
        const sSource = state.source;
        const sGlobalFilters = state.globalFilters;
        const sEventNames = state.eventNames;

        if (!sViewerId && !sClientId) {
          throw new Error('No valid User Id or Client Id found');
        }

        const queryIdType = sIdType
          ? sIdType
          : sViewerId
            ? EQueryIdType.userId
            : EQueryIdType.clientId;
        const tempId = queryIdType === EQueryIdType.userId ? sViewerId : sClientId;

        const redirectHandler = ({ id }) => {
          navigate(
            getAppViewerModuleTempDashboardUrl(
              {
                viewerId: sViewerId,
                clientId: sClientId,
                interval: sInterval,
                flowId: sFlowId,
              },
              id,
            ),
            {
              replace: true,
            },
          );
        };

        const title = queryIdType === EQueryIdType.userId ? 'User' : 'Client';

        dispatch(
          createTempDashboard(
            DASHBOARD_TYPE.APP_VIEWER_MODULE,
            {
              viewerId: sViewerId,
              clientId: sClientId,
              interval: sInterval,
              source: sSource,
              globalFilters: sGlobalFilters,
              idType: sIdType,
              eventNames: sEventNames,
              flowId: sFlowId,
            },
            `${title} - ${tempId}`,
            { redirectHandler },
          ),
        );
      } catch (e) {
        setError(true);
      }
    };
    fetchData();
  }, [dispatch, navigate, id]);

  return <Retry isLoading={!error} showError={error} />;
};

export default AppTimelineSharePage;
